import { FilterOption, FilterOptionType, HeadCell } from 'models';

export const headCells: readonly HeadCell[] = [
  {
    id: 'first_name',
    numeric: false,
    disablePadding: false,
    isSort: true,
    label: 'Sitter name',
  },
  {
    id: 'phone_number',
    numeric: false,
    disablePadding: false,
    isSort: false,
    label: 'Phone number',
  },
  {
    id: 'rating',
    numeric: false,
    disablePadding: false,
    isSort: true,
    label: 'Rating',
  },
  {
    id: 'payout_pending',
    numeric: false,
    disablePadding: false,
    isSort: false,
    label: 'Pending payouts',
  },
  {
    id: 'balance',
    numeric: true,
    disablePadding: false,
    isSort: true,
    label: 'Wallet balance',
  },
  {
    id: 'payoutMethod[account_holder_name]',
    numeric: false,
    disablePadding: false,
    isSort: false,
    label: 'Paynow name',
  },
  {
    id: 'payoutMethod[bank_account_number]',
    numeric: false,
    disablePadding: false,
    isSort: false,
    label: 'Paynow number',
  },
  {
    id: 'status',
    numeric: false,
    disablePadding: false,
    isSort: true,
    label: 'Status',
  },
];

export const filterOptions: FilterOption[] = [
  {
    name: 'First Name',
    key: 'first_name',
    type: FilterOptionType.TEXT,
    placeholder: 'Enter first name',
  },
  {
    name: 'Last Name',
    key: 'last_name',
    type: FilterOptionType.TEXT,
    placeholder: 'Enter last Name',
  },
  {
    name: 'Email',
    key: 'email',
    type: FilterOptionType.TEXT,
    placeholder: 'Enter email',
  },
  {
    name: 'Pending Payouts',
    key: 'pending_payout',
    type: FilterOptionType.SINGLE_CHECKBOX,
  },
];
